Object.defineProperty(exports, '__esModule', {
  value: true
});

// Customizable Area Start
exports.apiContentType = 'application/json';
exports.apiFormContentType = 'multipart/form-data';
exports.getApiMethod = 'GET';
exports.postApiMethod = 'POST';
exports.putApiMethod = 'PUT';

exports.getChatListApiEndPoint = 'chat/chats';
exports.showChatApiEndPoint = 'chat/chats';
exports.getChatHistoryApiEndPoint = 'chat/chats/history';
exports.searchMessageApiEndPoint = 'chat/chats/search_messages';
exports.searchChatGroupApiEndPoint = 'chat/chats/search';
exports.createChatRoomApiEndPoint = 'chat/chats';
exports.addUserToChatApiEndPoint = 'chat/chats/add_user';
exports.leaveChatApiEndPoint = 'chat/chats/leave';
exports.sendMessageApiEndPoint = 'chat/chats';
exports.updateReadMessageApiEndPoint = 'chat/chats/read_messages';
exports.updateChatApiEndPoint = 'chat/chats';

exports.getMyChatsApiEndpoint = 'chat/chats/mychats';

exports.createButtonText = 'Create';
exports.createRoomButtonText = 'Create Room'
exports.addButtonText = 'Add';
exports.closeButtonText = 'Close';
exports.addAccountText = 'Add Account';
exports.leaveChatRoomText = 'Leave Chat';
exports.sendText = 'Send';
exports.cancelText = 'Cancel';
exports.errorTitle = 'Error';
exports.errorAllFieldsAreMandatory = 'All fields are mandatory.';
exports.unreadMessageText = "Unread Messages";
exports.lastMessageText = "Last Message:";
exports.writeMessagePlaceholder = "Write message here";
exports.usersText = "Users:";
exports.accountIdPlaceholder = "Account ID";
exports.namePlaceholder = "Name";

exports.usersListApiEndpoint = "account_block/catalogues"
exports.activePlanApiEndpoint = "bx_block_order_management/sub_scription_orders/user_current_plan"

exports.TOKEN = "token"
exports.COMET_AUTH_TOKEN_KEY = "comet_auth_token"
exports.USER_PRESENCE_LISTENER = "USER_PRESENCE_LISTENER"
exports.chatsText = "Chats"
exports.acceptText = "Accept"
exports.deleteText = "Delete"
exports.blockText = "Block"
exports.typingText = "Typing..."
exports.unblockText = "Unblock"
exports.searchText = "Search"
exports.noUsersFoundText = "No users found!"
exports.noChatsToShowMessage = "No chats available to show"
exports.noChatsSelectedMessage = "No chats selected"
exports.typeAMessageText = "Type a message"
exports.deleteChatText = "Delete Chat"
exports.youBlockedThisUserText = "You blocked this user."
exports.deleteChatSubTitleText = "Are you sure you want to delete this chat?"
exports.blockUserSubTitlePreText = "Are you sure you want to block"
exports.unblockUserSubTitlePreText = "Are you sure you want to unblock"

exports.OPTIONS_POSITION_CONFIGURATION = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "right",
  }
}

exports.AllowedMimeTypes = [
  "image/jpeg", "image/png", "image/gif", "image/webp",  // Images
  "video/mp4", "video/webm", "video/quicktime",          // Videos
  "audio/mpeg", "audio/wav", "audio/ogg", "audio/x-m4a", // Audio
  "application/pdf", 
  "application/msword", 
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel", 
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
  "text/plain", 
  "application/zip", 
  "application/x-rar-compressed", 
  "text/csv", 
  "application/vnd.ms-powerpoint", 
  "application/vnd.openxmlformats-officedocument.presentationml.presentation"
];
  // Customizable Area End